<div class="row">
  <div class="col-lg-auto col-md-12 col-sm-12 d-flex justify-content-center">
    <div class="workspace-img-div">
      @if (avatarUrl()) {
        <img
          class="workspace-img-div"
          [ngSrc]="avatarUrl()"
          [alt]="'workspace_workspaceName' | translate"
          fill=""
          (error)="onImageError()" />
      } @else {
        <span
          class="c-full-white profile-text text-uppercase h-100 w-100 d-flex"
          [style.background-color]="timelineService.getColorFromName(workspaceName())">
          {{ workspaceName() | slice: 0 : 2 }}
        </span>
      }
      @if (canUpdateWorkspace()) {
        <button
          type="button"
          class="badge btn badge-edit-button"
          [attr.aria-label]="'edit' | translate"
          (click)="$event.stopPropagation(); editAvatar()">
          <i class="fa fa-cog fa-lg"></i>
        </button>
      }
    </div>
  </div>

  <div class="col-lg-11 col-md-12 col-sm-12 d-flex flex-wrap" [style.gap]="'5px'">
    <div class="w-100">
      <span class="f-12 _700">{{ 'workspace_workspaceName' | translate }}</span>
    </div>
    <div class="w-100">
      <form [formGroup]="headerForm" class="workspace-form" [ngClass]="{ 'has-danger': isNameInvalid() }">
        <input
          type="text"
          class="form-control input-section f-12 _400 w-100 ps-2"
          maxlength="64"
          [placeholder]="'workspace_workspaceName' | translate"
          [attr.aria-label]="'workspace_workspaceName' | translate"
          (input)="removeLeadingSpaces()"
          formControlName="name" />

        @if (headerForm.get('name').hasError('htmlNotAllowed') && headerForm.get('name').touched) {
          <span>{{ headerForm.get('name').getError('htmlNotAllowed') | translate }}</span>
        }

        @if (nameValue().length === 64) {
          <div>
            <small class="text-danger">{{ 'workspace_edit_nameCharLimit' | translate: { count: 64 } }}</small>
          </div>
        }
      </form>
    </div>
  </div>
</div>

<mtm-upload-file
  [preDefinedFilter]="['IMAGE_FILTER']"
  [hidden]="true"
  #avatarUploader
  (files)="fileChangeListener($event)"
  [style.display]="'none'">
</mtm-upload-file>
